<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <component :is="userData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
<!--    <b-alert-->
<!--      variant="danger"-->
<!--      :show="userData === undefined"-->
<!--    >-->
<!--      <h4 class="alert-heading">-->
<!--        Error fetching user data-->
<!--      </h4>-->
<!--      <div class="alert-body">-->
<!--        No user found with this user id. Check-->
<!--        <b-link-->
<!--          class="alert-link"-->
<!--          :to="{ name: 'apps-users-list'}"-->
<!--        >-->
<!--          User List-->
<!--        </b-link>-->
<!--        for other users.-->
<!--      </div>-->
<!--    </b-alert>-->

    <b-tabs
      v-if="userData"

    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">اطلاعات کاربر</span>
        </template>
        <user-edit-tab-account
          :user-data="userData"
          :selfie="selfie"
          class="mt-2 pt-75"
          @submitEdit="submitEdit"
        />
      </b-tab>

      <!-- Tab: Information -->
<!--      <b-tab>-->
<!--        <template #title>-->
<!--          <feather-icon-->
<!--            icon="InfoIcon"-->
<!--            size="16"-->
<!--            class="mr-0 mr-sm-50"-->
<!--          />-->
<!--          <span class="d-none d-sm-inline">Information</span>-->
<!--        </template>-->
<!--        <user-edit-tab-information class="mt-2 pt-75" />-->
<!--      </b-tab>-->

      <!-- Tab: Social -->
<!--      <b-tab>-->
<!--        <template #title>-->
<!--          <feather-icon-->
<!--            icon="Share2Icon"-->
<!--            size="16"-->
<!--            class="mr-0 mr-sm-50"-->
<!--          />-->
<!--          <span class="d-none d-sm-inline">Social</span>-->
<!--        </template>-->
<!--        <user-edit-tab-social class="mt-2 pt-75" />-->
<!--      </b-tab>-->
    </b-tabs>
  </component>
  </b-overlay>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BOverlay,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import userStoreModule from '../userStoreModule'
import UserEditTabAccount from './UserEditTabAccount.vue'
import UserEditTabInformation from './UserEditTabInformation.vue'
import UserEditTabSocial from './UserEditTabSocial.vue'
import {UsersGetRequest} from "@/libs/Api/Users";
import {UsersUpdateByAdminRequest} from "@/libs/Api/Users";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  title:"اطلاعات کاربر - پنل ادمین نهایی شو",
  data(){
    return{
      userId:this.$route.params.id,
      overlay:false,
      userData:null,
      selfie:null,
    }
  },
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BOverlay,

    UserEditTabAccount,
    UserEditTabInformation,
    UserEditTabSocial,
  },
  async created(){
    await this.getUser();
  },
  methods:{
    async getUser(){
      let _this = this;
      _this.overlay = true;

      let usersGetRequest = new UsersGetRequest(_this);
      usersGetRequest.setUserId(_this.userId);
      await usersGetRequest.fetch(function (content){
        _this.overlay = false;
        _this.userData = content;
        _this.selfie = content.selfieFileData;
        _this.userData.selfieFileData = null;
      },function (error){
        _this.overlay = false;
        console.log(error)
      })
    },
    async submitEdit(){
      let _this = this;
      _this.overlay = true;

      let usersUpdateByAdminRequest = new UsersUpdateByAdminRequest(_this);
      usersUpdateByAdminRequest.setParams(_this.userData);
      await usersUpdateByAdminRequest.fetch(function (content){
        _this.overlay = false;
        if (content === 1){
          return  _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CloseIcon',
              variant: 'danger',
              text: `این نام کاربری قبلا ثبت شده است.`,
            },
          })
        }
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `تغییرات اعمال شد.`,
          },
        })
        _this.getUser()
      },function (error){
        _this.overlay = false;
        console.log(error)
      })
    },
  },
  setup() {
    const userData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-user'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-user/fetchUser', { id: router.currentRoute.params.id })
      .then(response => { userData.value = response.data })
      .catch(error => {
        if (error.response.status === 404) {
          userData.value = undefined
        }
      })

    return {
      // userData,
    }
  },
}
</script>

<style>

</style>
